import { render, staticRenderFns } from "./vueordinarylist.vue?vue&type=template&id=4140fb22&scoped=true"
import script from "./vueordinarylist.vue?vue&type=script&lang=js"
export * from "./vueordinarylist.vue?vue&type=script&lang=js"
import style0 from "./vueordinarylist.vue?vue&type=style&index=0&id=4140fb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4140fb22",
  null
  
)

export default component.exports